import type React from 'react';

import { Body, Media, Wrapper } from './wrapper';

export type InlineMediaContentGapProps = 'small';

interface InlineMediaContentProps {
  media?: React.ReactNode;
  children?: React.ReactNode;
  gap?: InlineMediaContentGapProps;
}

const InlineMediaContent = ({ media, children, gap }: InlineMediaContentProps) => (
  <Wrapper $gap={gap}>
    {media && <Media>{media}</Media>}
    <Body>{children}</Body>
  </Wrapper>
);

export default InlineMediaContent;
